import { DocumentRequestBody, DocumentRequestTemplateRequestParameter, SendMessageRequestBody } from "../../common/model/sse/requestBody";
import { DocumentRequestTemplateResponse } from "../../common/model/sse/responseBody";
import { SSE_ComposeMessage_sendMessageParameter, SSE_DocumentRequestApi_documentRequestParameter, SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter } from "../apiParameters";
import { baseResponseBody } from "../objectTypeConstants";

export const sendMessageRequestBody : SendMessageRequestBody = {
    recipients: SSE_ComposeMessage_sendMessageParameter.recipients,
    subject:SSE_ComposeMessage_sendMessageParameter.subject,
    body:SSE_ComposeMessage_sendMessageParameter.body,
    retentionPeriod: SSE_ComposeMessage_sendMessageParameter.retentionPeriod,
    attachments:SSE_ComposeMessage_sendMessageParameter.attachments,
    callbackUri:SSE_ComposeMessage_sendMessageParameter.callbackUri,
    correlationId :SSE_ComposeMessage_sendMessageParameter.correlationId,
}

export const documentRequestBody : DocumentRequestBody = {
    recipients: SSE_DocumentRequestApi_documentRequestParameter.recipients,
    subject:SSE_DocumentRequestApi_documentRequestParameter.subject,
    templateName:SSE_DocumentRequestApi_documentRequestParameter.templateName,
    retentionPeriod: SSE_DocumentRequestApi_documentRequestParameter.retentionPeriod,  
    notifyOnCompletion:SSE_DocumentRequestApi_documentRequestParameter.notifyOnCompletion,
}

export const documentRequestTemplateBody : DocumentRequestTemplateRequestParameter = {
    filterTextQuery: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.filterTextQuery,
    pageNumberQuery: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.pageNumberQuery,
    pageSizeQuery: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.pageSizeQuery,
    sortColumnQuery: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.sortColumnQuery,
    sortOrderQuery: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.sortOrderQuery,
}

export const  documentRequestTemplateResponse : DocumentRequestTemplateResponse = {
    ...baseResponseBody,
    data: {
        documentRequestTemplateId: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentRequestTemplateId,
        name: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.name,
        description: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.description,
        createdDate: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.createdDate,
        modifiedDate: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.modifiedDate,
        year: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.year,
        dueDate: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.dueDate,
        documentListName: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListName,
        documentListDescription: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListDescription,
        documentListCategoryCount: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListCategoryCount,
        documentListCategoryId: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListCategoryId,
        documentListCategoryName: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListCategoryName,
        documentListCategoryCreatedDate: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListCategoryCreatedDate,
        documentListCategoryModifiedDate: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListCategoryModifiedDate,
        documentListCategoryCreatedBy: SSE_DocumentRequestTemplate_DocumentRequestTemplateParameter.documentListCategoryCreatedBy,
    }
}
